<template>
  <div class="box">
    <el-form :model="info" label-position="right" :rules="rules" ref="ruleForm" label-width="80px" size="small">
      <el-form-item label="类型" prop="type">
        <el-radio-group v-model="info.type">
          <el-radio :label="1">增加</el-radio>
          <el-radio :label="2">减少</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="积分数" prop="sum">
        <el-input-number v-model="info.sum" placeholder="请输入数量" controls-position="right" style="width: 160px"></el-input-number>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="info.remark" placeholder="请输入备注"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>

export default {
  data() {
    return {
      info: {
        id: 0,
        type: 1,
        sum: '',
        remark: ''
      },
      rules: {
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ],
        sum: [
          { required: true, trigger: 'blur',validator: function (rule, value, callback) {
              if ( !value) {
                return callback( new Error( '请输入积分数'));
              } else if(value < 1) {
                return callback( new Error( '请输入正确的积分数'));
              } else {
                return callback()
              }
            }
          }
        ],
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
  },
  mounted() {
  },
  computed: {
  },
  props: {
    memberId: Number,
    callFunc: Function
  },
  watch: {
    'memberId': {
      handler (newValue, oldValue) {
        this.info.id = newValue
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    submitForm(formName) {
      var _this = this
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          var param = _this.info
          this.$api.member.memberIntegralUpdate(param,function (res) {
            if(res.errcode == 0) {
              _this.success(res.errmsg)
              _this.callFunc()
            } else {
              _this.fail(res.errmsg)
            }
          })
        } else {
          return false;
        }
      });
    },
  }
};
</script>
<style scoped>
</style>
